import IncomingOffers from "./IncomingOffers";

export default IncomingOffers;
